import React from "react";
import { matchPath } from "react-router-dom";

import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

type ReduceChildRoutesProps = {
  depth: number;
  page: SidebarItemsType;
  items: JSX.Element[];
  currentRoute: string;
  onClose?: () => void;
};

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute, onClose } = props;

  const dataTourAttr =
    page.tourStep !== undefined
      ? { dataTour: `sidebar-item-${page.tourStep}` }
      : {};

  if (page.children) {
    const open = page.href
      ? !!matchPath(
          {
            path: page.href,
            end: false,
          },
          currentRoute
        )
      : false;

    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        open={!!open}
        title={page.title}
        href={page.href}
        disabled={page.disabled}
        alt={page.alt}
        onClick={props.onClose}
        {...dataTourAttr}
      >
        <SidebarNavList
          depth={depth + 1}
          pages={page.children}
          onClose={onClose}
        />
      </SidebarNavListItem>
    );
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        title={page.title}
        disabled={page.disabled}
        alt={page.alt}
        onClick={props.onClose}
        {...dataTourAttr}
      />
    );
  }

  return items;
};

export default reduceChildRoutes;
